import type { ReactNode, RefObject } from 'react'

import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet'
import { SheetClose } from '@/components/ui/sheet'

interface MasterDataEditSheetProps {
  readonly open: boolean
  readonly onOpenChange: (open: boolean) => void
  readonly title: string
  readonly children: ReactNode
  readonly triggerRef: RefObject<HTMLButtonElement | null>
  readonly formId: string
  readonly saveTestId: string
  readonly saveDisabled: boolean
  readonly isSaving: boolean
}

/** Gemeinsame reine Präsentationshülle für die sechs Objekteditoren. Sie
 * besitzt weder Entwurf noch Request noch Validierung; das bleibt beim
 * jeweiligen Fachformular. */
export function MasterDataEditSheet({ open, onOpenChange, title, children, triggerRef, formId, saveTestId, saveDisabled, isSaving }: MasterDataEditSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        showCloseButton={false}
        onCloseAutoFocus={(event) => {
          event.preventDefault()
          triggerRef.current?.focus()
        }}
        className="data-[side=right]:!w-full data-[side=right]:sm:!max-w-none md:data-[side=right]:!w-[560px] md:data-[side=right]:!max-w-[560px]"
      >
        <div className="flex h-full flex-col">
          <SheetHeader className="flex-row items-center justify-between gap-2">
            <SheetClose asChild>
              <button type="button" data-testid="master-data-edit-cancel" className="border-border text-text min-h-(--tap-min) min-w-(--tap-min) border px-3">Abbrechen</button>
            </SheetClose>
            <SheetTitle className="text-section font-(--font-weight-section) text-text min-w-0 flex-1 text-center">{title}</SheetTitle>
            <button type="submit" form={formId} data-testid={saveTestId} disabled={saveDisabled} aria-busy={isSaving} className="bg-accent rounded-card text-body min-h-(--tap-min) px-4 text-accent-on disabled:opacity-60">{isSaving ? 'Speichern…' : 'Speichern'}</button>
          </SheetHeader>
          {children}
        </div>
      </SheetContent>
    </Sheet>
  )
}
